import React from 'react';
import SecondaryButtonSingleVoyage
    from "@containers/singleVoyage/ui/buttonts/secondaryButtonSingleVoyage/SecondaryButtonSingleVoyage";
import {useTranslation} from 'react-i18next';
import {
    useSaveVoyageMutateSingleVoyage
} from "@containers/singleVoyage/mutateVoyage/saveVoyage/hooks/useSaveVoyageMutateSingleVoyage";
import {SxType} from "@baseTypes/sx/sxTypes";

const sx:SxType = {
    btn:{
        flexShrink: 0,
    }
}
const SaveVoyage = () => {

    const {t} = useTranslation()

    const {onSave} = useSaveVoyageMutateSingleVoyage()

    return (
        <SecondaryButtonSingleVoyage
            sx={sx.btn}
            onClick={onSave}
        >
            {t('base.save')}
        </SecondaryButtonSingleVoyage>
    );
};

export default SaveVoyage;
